/**
 * @GENERATED from Figma node 3638:51930
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const PowerpointBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6.5 2.92v18.16c0 1.06.846 1.92 1.89 1.92h12.72c1.044 0 1.89-.86 1.89-1.92V6.053c0-.513-.202-1.005-.561-1.366L19.32 1.555A1.88 1.88 0 0 0 17.99 1h-9.6C7.347 1 6.5 1.86 6.5 2.92"
      clipRule="evenodd"
    />
    <path
      fill="#9D9C9B"
      fillRule="evenodd"
      d="M6.5 2.92v18.16c0 1.06.846 1.92 1.89 1.92h12.72c1.044 0 1.89-.86 1.89-1.92V6.053c0-.513-.202-1.005-.561-1.366L19.32 1.555A1.88 1.88 0 0 0 17.99 1h-9.6C7.347 1 6.5 1.86 6.5 2.92m1.203 18.16V2.92c0-.385.308-.698.688-.698h9.367v4.19a1.3 1.3 0 0 0 1.289 1.31h2.75V21.08a.693.693 0 0 1-.688.699H8.391a.693.693 0 0 1-.688-.699M21.797 6.5v-.446a.7.7 0 0 0-.204-.497L18.96 2.913v3.5c0 .048.038.087.086.087z"
      clipRule="evenodd"
    />
    <path
      fill="#E48762"
      d="M14.75 17.5q4.125 0 4.125-4.125h-2.75v-2.75H14.75V17.5"
    />
    <path fill="#F9D4C4" d="M17.5 12V9.25c1.031 0 2.75 1.719 2.75 2.75z" />
    <path
      fill="#C25B33"
      d="M1 7.36c0-.57.462-1.032 1.031-1.032h10.313c.57 0 1.031.462 1.031 1.031v10.313c0 .57-.462 1.031-1.031 1.031H2.03c-.57 0-1.031-.462-1.031-1.031z"
    />
    <path
      fill="#fff"
      d="M5.125 15.796v-6.89h1.833q1.025 0 1.34.099.502.16.826.681.33.522.33 1.345 0 .747-.283 1.254-.282.504-.705.71-.422.202-1.456.202h-.748v2.599zm1.137-5.724v1.955h.63q.635 0 .86-.09a.77.77 0 0 0 .376-.319q.146-.236.146-.573 0-.344-.15-.578a.74.74 0 0 0-.372-.315q-.22-.08-.935-.08z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(PowerpointBright);
export { ForwardRef as PowerpointBright };
